export default "__VITE_ASSET__DWv8nX6j__"